// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__VQKnG"};